export enum SubjectResourceType {
  Claim = 'Claim',
  Condition = 'Condition',
  DynamicForm = 'DynamicForm',
  Form = 'Form',
  Measure = 'Measure',
  MeasureReview = 'MeasureReview',
  MeasureScore = 'MeasureScore',
  MeasurePeriodScore = 'MeasurePeriodScore',
  Note = 'Note',
  Person = 'Person',
  Profile = 'Profile',
  Program = 'Program',
  ProgramInstance = 'ProgramInstance',
  Provider = 'Provider',
  Risk = 'Risk',
  RiskAdjustment = 'RiskAdjustment',
  Signature = 'Signature',
  User = 'User',
  RiskEvidence = 'RiskEvidence',
}
